/** @jsx jsx */
import * as React from "react";
import { jsx, Themed } from "theme-ui";

import SkipLink from "./SkipLink";
import Header from "./Header";

interface LayoutProps {
  children: MyReactNode;
  headerContent: MyReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children, headerContent }) => {
  return (
    <Themed.root>
      <SkipLink href="#content">Skip to main content</SkipLink>
      <Header siteTitle="Character Table">{headerContent}</Header>
      <main
        id="content"
        sx={{
          display: "grid",
          gridTemplateColumns:
            "2fr 1fr minmax(auto, calc(var(--rhythm) * 30)) 1fr 2fr",
          "& > *": {
            gridColumn: "3/4",
          },
          py: 0,
          px: [4, 4, 0],
        }}
      >
        {children}
      </main>
      <footer
        sx={{
          p: 4,
          mt: 7,
          bg: "header",
          textAlign: "center",
          variant: "heading",
          display: "flex",
          justifyContent: "center",
          borderTop: (theme) => `1px solid ${theme.colors?.highlightCode}`,
        }}
      >
        <Themed.a
          sx={{
            variant: "links.ui",
            fontWeight: "normal",
            fontStyle: "italic",
          }}
          href="https://markoskon.com"
        >
          Markos Konstantopoulos
        </Themed.a>
      </footer>
    </Themed.root>
  );
};

export default Layout;
